import * as React from "react";
function SvgLittleredbook(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <rect fill="#F19DA7" height={32} rx={6} width={32} />
      <path
        d="M17.5 3.5v25l-9-3.5V7.33zm3.1 2.7l2.9-.7v21l-3-.7 1.9-.49V6.71z"
        fill="#fff"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLittleredbook);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
